<template>
    <div>
        <ob-modal2 :show.sync="show" width="700px">
            <template slot="modal-title">
               <div class="col-md-3 p0" > Job Details</div>
               <!-- <div class="col-md-9 text-right p0"> <button class="job-Details-edit" @click="isEditUpdate" :disabled="!projectdetails.IsEdit">Edit</button></div> -->
            </template>
            <template slot="modal-body">
                <div class="project-detais-con" v-if="isUpdateData">
                    <div class="project-details-job">
                        <div class="row" v-if="!projectdetails.IsEdit" >
                            <!-- <span class="content-war-message"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/icons/info-icon-orange.svg`" class="warning-message">LCAs have been filed for this project. You will not be able to Edit it. Please add a new project.</span> -->
                        </div>
                        <div class="row m0 details-show-con">
                            <div class="col-md-4">
                                <span class="top-job-label">Job Title</span>
                                <span class="top-job-details" :title="projectdetails.JobName" v-if="projectdetails.JobName !=''">{{projectdetails.JobName}}</span>
                                <span class="headline-message" v-else>N/A</span>
                            </div>
                            <div class="col-md-4">
                                <span class="top-job-label">Experience</span>
                                <span class="top-job-details" v-if="projectdetails.Experience != 0">{{projectdetails.Experience}}</span>
                                <span class="top-job-details" v-else>N/A</span>
                                <!-- <span class="top-job-details" v-if="projectdetails.MinExperience != 0">{{ projectdetails.MinExperience}}</span><span  class="top-job-details" v-if="projectdetails.MaxExperience != 0"> - {{projectdetails.MaxExperience}} years</span> -->
                                <!-- <span class="top-job-details" v-if="projectdetails.MinExperience == 0 && projectdetails.MaxExperience == 0">N/A</span> -->
                                <!--<span class="headline-message" v-else>N/A</span>-->
                            </div>
                            <div class="col-md-4">
                                <span class="top-job-label">Education Qualification</span>
                                <span class="top-job-details" :title="projectdetails.Qualification" v-if="projectdetails.Qualification !='' && projectdetails.Qualification != null ">{{projectdetails.Qualification}}</span>
                                <span class="top-job-details" v-else>N/A</span>
                            </div>
                        </div>
                        <div class="row m0 details-show-con">
                            <div class="col-md-12">
                                <span class="top-job-label">Job Description</span>
                                <div class="top-job-description" v-if="projectdetails.Description !=''" v-html="projectdetails.Description"></div>
                                <span class="top-job-details" v-else>N/A</span>
                            </div>
                        </div>
                        <div class="row m0 details-show-con">
                            <div class="col-md-12">
                                <div class="keyskill-container">
                                    <span class="top-job-label">Key Skills</span>
                                    <span v-if="projectdetails && projectdetails.Skills.length > 0">
                                       <span class="top-job-details keyskill-details" v-for="skills in projectdetails.Skills">{{skills}}</span>
                                    </span>
                                    <span class="top-job-details" v-else>N/A</span>
                                </div>
                            </div>
                        </div>
                         <div class="row m0 details-show-con">
                            <div class="col-md-12 pL0">
                                <span class="top-job-label" style="padding-left: 15px;">Require Supervisory Skills</span>
                                <p class="headline-message" style="padding-left: 20px;" v-if="projectdetails.IsSupervisorSkillRequired == true">Yes</p>
                                <p class="headline-message" style="padding-left: 20px;" v-else-if="projectdetails.IsSupervisorSkillRequired == false">No</p>
                                <p class="headline-message" style="padding-left: 20px;" v-else-if="projectdetails.IsSupervisorSkillRequired == null || projectdetails.IsSupervisorSkillRequired == ''">N/A</p>
                            </div>
                        </div>

                        <div class="row m0 details-show-con">
                            <div class="col-md-12 pL0">
                                <span class="top-job-label" style="padding-left: 15px;">Additional Activities/Tasks</span>
                                <p class="headline-message" style="padding-left: 20px;" v-if="projectdetails.RequiredActivities == null">N/A</p>
                                <ul style="padding-left: 50px;" v-else>
                                    <li class="headline-message" v-for="(reqActivity,rIndex) in projectdetails.RequiredActivities" :key="rIndex">{{reqActivity}}</li>
                                </ul>
                            </div>
                        </div>

                        <div class="row m0 details-show-con" >
                            <div class="col-md-12 pL0">
                                <span class="top-job-label" style="padding-left: 15px;">Required Special skills, Tasks / Certifications</span>
                                <ul style="padding-left: 50px;" v-if="projectdetails.IsIndividualDecitionRequired == true || projectdetails.IsComplexityInSkillsRequired == true || projectdetails.IsSpecialCertificationsRequired == true ">
                                    <li class="headline-message" v-if="projectdetails.IsComplexityInSkillsRequired == true">This job requires a higher level of complexity in skills, knowledge, work, activities, tasks.</li>
                                    <li class="headline-message" v-if="projectdetails.IsSpecialCertificationsRequired == true">This job requires candidates with special certification or license.</li>
                                    <li class="headline-message" v-if="projectdetails.IsIndividualDecitionRequired == true"> This job requires the candidates to make individual decisions without supervision.</li>
                                </ul>
                                <p class="headline-message" style="padding-left: 20px;" v-else>N/A</p>
                            </div>
                        </div>

                    </div>
                </div>
               <div v-if="!isUpdateData">
                  <div class="row m0">
                        <div class="col-md-4 pL0">
                              <div class="form-group">
                              <label> Job title </label><span class="validation-star">*</span>
                              <ob-input type="text" :class="{ 'ob-vuelidate_input-error': $v.projectdetails.JobName.$error }" placeholder="Enter job title"
                                    v-model.trim="projectdetails.JobName" style="border-radius: 4px !important;"></ob-input>
                              <span class="ob-vuelidate_error-msg" v-if="$v.projectdetails.JobName.$dirty && !$v.projectdetails.JobName.required">Please enter job title</span>
                              <!--<span class="ob-vuelidate_error-msg" v-if="$v.projectdetails.JobName.$dirty && !$v.projectdetails.JobName.maxLength">Please enter 500 characters only</span>
                                          <span class="ob-vuelidate_error-msg" v-if="$v.projectdetails.JobName.$dirty && !$v.projectdetails.JobName.letterCount500">Each word can have a maximum of 100 characters only.</span>-->
                              </div>
                        </div>
                        <div class="col-md-4">
                              <div class="col-md-6 duration-block" style="padding-left:0px;">
                                    <div class="form-group" v-bind:class="{ 'ob-vuelidate_error-msg': $v.projectdetails.MinExperience.$error || $v.projectdetails.MaxExperience.$error }">
                                          <label>Experience </label>
                                          <ob-input v-number-only="true" :maxLength="10" placeholder="Min" v-bind:class="{ 'ob-vuelidate_input-error': $v.projectdetails.MinExperience.$error }" v-model.trim="projectdetails.MinExperience"> </ob-input>
                                          <!--<span class="ob-vuelidate_error-msg" v-if="$v.projectdetails.MinExperience.$dirty && !$v.projectdetails.MinExperience.required">Please enter minimum experience</span>-->
                                          <span class="ob-vuelidate_error-msg" v-if="$v.projectdetails.MinExperience.$dirty && !$v.projectdetails.MinExperience.maxLength">Please enter only 2 digits</span>
                                    </div>
                              </div>

                              <div class="col-md-6 duration-block pR0">
                                    <div class="form-group">
                                          <label>&nbsp;</label>
                                          <ob-input v-number-only="true" placeholder="Max" :maxLength="10" v-bind:class="{ 'ob-vuelidate_input-error': $v.projectdetails.MaxExperience.$error }" v-model.trim="projectdetails.MaxExperience"> </ob-input>
                                          <!--<span class="ob-vuelidate_error-msg" v-if="$v.projectdetails.MaxExperience.$dirty && !$v.projectdetails.MaxExperience.required">Please enter maximum experience</span>-->
                                          <span class="ob-vuelidate_error-msg" v-if="$v.projectdetails.MinExperience.$dirty && !$v.projectdetails.MaxExperience.maxLength">Please enter only 2 digits</span>
                                          <span class="ob-vuelidate_error-msg" v-if="$v.projectdetails.MinExperience.$dirty && !$v.projectdetails.MaxExperience.minValue">Please enter greater than minimum</span>
                                    </div>

                              </div>
                        </div>
                        <div class="col-md-4">
                              <div class="form-group">
                                    <label> Educational Qualification </label>
                                    <ob-select2 :options="educationQualifyOpt" :inputData ="EducationData" v-if="showEducationalQual" v-model.trim="projectdetails.Qualification"></ob-select2>
                                    <!--<span class="ob-vuelidate_error-msg" v-if="$v.projectdetails.EducationQual.$dirty && !$v.projectdetails.EducationQual.required">Please enter educational qualification</span>-->
                              </div>
                        </div>
                  </div>
                  <div class="row">
                        <div class="col-md-12 section-padding">
                              <div class="col-md-12 compose-mail__section--textarea" style="padding:0px;">
                              <div class="form-group">
                                    <label> Job Description </label><span class="validation-star">*</span>
                                    <div :class="{ 'ob-vuelidate_input-error': $v.projectdetails.Description.$error }">
                                          <!-- <tinymce :height="200+'px'" className="body_content" :inputData ="JobDescription" :toolbar-required="true" :auto-resize="false" @textareaInput="jobDescriptionInput" ></tinymce> -->
                                          <span class="ob-vuelidate_error-msg" v-if="$v.projectdetails.Description.$dirty && !$v.projectdetails.Description.required">Please enter job description</span>
                                    </div>
                              </div>

                              </div>
                        </div>
                  </div>
                  <div class="row">
                        <div class="col-md-12 section-padding">
                              <div class="form-group">
                              <label> Key Skills </label>
                              <ob-select2 :initialData="keySkillsArr" :options="keySkillsOpt" :multiple="true" v-model.trim="projectdetails.Skills" ></ob-select2>
                              <!--<span class="ob-vuelidate_error-msg" v-if="$v.projectdetails.KeySkills.$dirty && !$v.projectdetails.KeySkills.required">Please enter key skills</span>-->
                              </div>
                        </div>
                  </div>
               </div>
</template>
<template slot="modal-footer">
    <ob-button type="secondary" @click="show = false">Close</ob-button>
    <ob-button type="primary" @click="updateiewJobInfo" v-if="!isUpdateData">Update</ob-button>
</template>

</ob-modal2>
</div>
</template>


<script>
import c from '@/components/Core/constants.js'
//import tinymce from "Vue/Components/tinymce.vue";
 import { required, requiredIf, maxLength, alpha, email, minValue } from 'vuelidate/lib/validators'
    export default {
        props: {
            isViewDetailsshow: {
            },
            projectDetailsData: {}
        },
        data() {
            return {
                show: '',
                isUpdateData: true,
                JobDescription:'',
                projectdetails:'',
                keySkillsArr:[],
                EducationData:[],
                showEducationalQual:true,
                showKeySkills:false,
                educationQualifyOpt:{
            placeholder: {
                id: '-1',
                text: 'Select'
            },
            data: []
        },
        keySkillsOpt:{
            ajax: {
                type: 'GET',
                url: function (params) {
                    return `${c.APIBASEURL}/Job/GetKeySkillByName?name=${params.term}`
                },
                delay: 250,
                data: function (params) {
                    return {
                        searchWord: params.term //search term
                    };
                },
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                },
                processResults: function (data, params) {
                    data = JSON.parse(data);
                    let results = []
                    if(data != null){
                        data.list.forEach((e)=>{
                            results.push({
                                id: e.Name,
                                text: e.Name
                            })
                        })
                    }
                    return {
                       results: results
                    };
                },
                cache: true
            },
            minimumInputLength: 1,
            escapeMarkup: function (markup) { return markup; },
            templateResult: function (cities) {
                if (cities.loading)
                    return cities.text;
                var markup = '<option value="' + cities.text + '">' + cities.text + '</option>';

                return markup;
            },
            templateSelection: function (cities) { return cities.text },
            tags: true,
            tokenSeparators: [','],
            createTag: function (params) {
                let lastElem = params.term
                var count = lastElem.match(/\S+/g).length;
                if (count <= 3 && count > 0) {
                    var userVal = lastElem.match(/\S+/g);

                    for (var i = 0; i < userVal.length; i++) {

                        if (userVal[i].length > 15 && userVal[i].length > 0) {
                            return null
                        }
                    }
                    return {
                        id: "##" + params.term,
                        text: params.term,
                        newOption: true
                    }
                }
                else {
                    return null
                }

            },
            placeholder: 'Add key skills'
        }
            }
        },

        watch: {
            isViewDetailsshow(val) {
                this.show = val
            },
            show(val) {
                
                this.$emit('update:isViewDetailsshow', val)
                if(val == false){
                    this.isUpdateData= true 
                }
                if(val == true){
                    this.resetdetailsdata()
                    this.projectdetails.JobId = this.projectDetailsData.JobId
                    this.projectdetails.JobName = this.projectDetailsData.JobName
                    this.projectdetails.Description = this.projectDetailsData.Description
                    this.projectdetails.Skills= this.projectDetailsData.Skills
                    this.projectdetails.Qualification = this.projectDetailsData.Qualification
                    this.projectdetails.MinExperience= this.projectDetailsData.MinExperience
                    this.projectdetails.MaxExperience =this.projectDetailsData.MaxExperience
                }
            },
            isUpdateData(g){
                if(g == false){
                    
                    this.keySkillsArr=[]                     
                    this.getAllSelect2Data(this.projectdetails.Qualification)
                    this.JobDescription = this.projectdetails.Description  
                     if(this.projectdetails.Skills != null){
                         this.showKeySkills = false
                this.projectdetails.Skills.forEach((k)=>{
                    let obj = {
                        id:k,
                        text:k
                    }
                    this.keySkillsArr.push(obj)
                })
                this.showKeySkills = true

            }                
                }
                if(g == true){
                    this.projectdetails.JobId = this.projectDetailsData.JobId
                    this.projectdetails.JobName = this.projectDetailsData.JobName
                    this.projectdetails.Description = this.projectDetailsData.Description
                    this.projectdetails.Skills= this.projectDetailsData.Skills
                    this.projectdetails.Qualification = this.projectDetailsData.Qualification
                    this.projectdetails.MinExperience= this.projectDetailsData.MinExperience
                    this.projectdetails.MaxExperience =this.projectDetailsData.MaxExperience
                }
            }


        },
      //   components:{       
      //           "tinymce": tinymce
      //       },
            computed:{
                showEditBtn(){
                    if(this.projectdetails.IsEdit && !this.projectdetails.IsATS){
                        return true
                    }
                    else{
                        return false
                    }
                }

            },
        created() {
            this.show = this.isViewDetailsshow
            this.getAllSelect2Data()
            this.projectdetails = __.cloneDeep(this.projectDetailsData)
        },
validations() {
        return{
            projectdetails:{ 
                MinExperience:{
                    maxLength:maxLength(2)
                },
                MaxExperience:{
                    maxLength:maxLength(2),
                    minValue: minValue(parseInt(this.projectdetails.MinExperience, 10) + 1)
                },
                Description:{
                      required
                },
                 JobName:{
                     required
                },
                
            },
        }
    },
    methods:{
        resetdetailsdata(){
                    this.keySkillsArr=[] 
                    this.$v.projectdetails.$reset()
                    this.projectdetails.JobId =''
                    this.projectdetails.JobName =''
                    this.projectdetails.Description =''
                    this.projectdetails.Skills=''
                    this.projectdetails.Qualification =''
                    this.projectdetails.MinExperience=''
                    this.projectdetails.MaxExperience =''
        },
        isEditUpdate(){
                this.isUpdateData = false
        },
          jobDescriptionInput(v){
            this.projectdetails.Description = v
        },
         getAllSelect2Data(e){
        //       //Educational qualification
        this.showEducationalQual = false
              ajax.get(`/Consultant/GetDegreeNames`, {}, (res) => {
                  this.educationQualifyOpt.data = __.map(res.data, (t) => {
                      return { 'id': t , 'text': t }
                  })
                  this.showEducationalQual = true
                  this.projectdetails.Qualification = e

              })
          },
          updateiewJobInfo(){
                this.$v.projectdetails.$touch()
            if(this.$v.projectdetails.$invalid == false){
              let params={
                    Id :this.projectdetails.JobId,
                    JobName: this.projectdetails.JobName,
                    Description:this.projectdetails.Description,
                    KeySkills:this.projectdetails.Skills,
                    EducationalQualification:this.projectdetails.Qualification,
                    MinExp:this.projectdetails.MinExperience,
                    MaxExp:this.projectdetails.MaxExperience

              }
            this.$loading({'loadingText': 'Loading...'})
                       ajax.post(`/OnBoard/UpdateJob`,params, (res) =>{          
                  if(res.data.State == true) {  
                        this.$loading({}).close()  
                        this.$message({
                                type: 'success',
                                message: 'Job Details updated successfully'
                            })
                        let dataDetails = __.cloneDeep(this.projectdetails)
                         let tempSkills = []
                        dataDetails.Skills.forEach((e)=>{                           
                            var array = e.replace("##", "")
                            tempSkills.push(array)                            
                        })
                        dataDetails.Skills=tempSkills
                        this.$emit('update:projectDetailsData', dataDetails)
                        this.isUpdateData = true
                  } else {
                        this.$loading({}).close()  
                        ///this.ESSEnableDisable(res) 
                        this.$message({
                            type: 'error',
                            message: res.data.Message
                        })
                  }

             })
          }
          }
    }

    }
</script>


<style lang="scss" scoped>
    /*popup styles*/
    .modal-soc--body {
        text-align: center;
        padding: 25px;
        font-weight: 600;
    }

    .modal-soc--footer {
        text-align: center;
        padding: 0px 15px 25px;
    }
    .top-job-details{
    font-weight: 600;
    color: #143361;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    //display: block;
    }
    .top-job-label{
        color: #777;
    display: inline-block;
    width: 100%;
    }
    .details-show-con{
            padding: 10px 0px;
    }
    .keyskill-details{
    border: 1px solid #eee;
    padding: 6px;
    border-radius: 5px;
    margin: 4px 4px 4px 0;
    display: inline-block !important;
    background: #fff;
    }
    .keyskill-container{
        background: #f0f7ff;
    padding: 10px;
    }
    .top-job-description {
    font-weight: 600;
    color: #143361 !important;
    }
    .job-Details-edit{
        text-align: right;
        font-weight: 400;
        font-size: 14px;
        text-decoration: underline;
        font-style: italic;
        background: #fff;
        border: 0;
    }
    .validation-star{
                color: #F31D1D;
        }
        .warning-message{
            width: 18px;
            margin-left: 12px;
            margin-right: 5px;
        }
        .content-war-message{
            color: #f07431;
        }

</style>
<style lang="scss">
.top-job-description {
    p {
        font-weight: 600;
        color: #143361;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/ESSProjects/viewJobDetailsPopUp.vue